<template lang="html">
   <div class="connection-lost" v-show="internet_connection === 'offline'">
      <div class="row justify-content-md-center">
         <div class="col-md-10 col-lg-9 col-xl-8 tx-center">
            <img src="/img/connection.svg" alt="" class="err-img">

            <div class="h2">Internet Connection Lost!</div>
            <div class="t5">This message will automatically dissapear when an internet connection is established.</div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   beforeDestroy () {
      clearInterval(this.timeout)
   },
   data(){
      return {
         internet_connection,
         timeout: null
      };
   },
   mounted(){
      this.timeout = setInterval(() => {
         this.internet_connection = internet_connection
      }, 3000)
   },
   
}
</script>

<style lang="scss">
   .connection-lost{
      position: fixed;
      z-index: 3000;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      // background: $white;
      -webkit-backdrop-filter: blur(3px);
      backdrop-filter: blur(3px);
      background-color: hsla(100%, 100%, 100%, 0.808);

      .err-img{
         margin: 10% 0;
         width: auto;
         height: auto;
         max-width: 45%;
      }

      .h2{
         animation-name: pulse;
         animation-duration: 2s;
         animation-timing-function: ease-in-out;
         animation-iteration-count: infinite;
      }

      @keyframes pulse {
         0% {color: $danger;}
         50% {color: darken($danger,15%);}
         100% {color: $danger;}
      }
   }
</style>